import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export type AppState = {
  history: string[];
  goBack: () => void;
  resetHistory: () => void;
};

export const AppContext = createContext<AppState>({
  history: [],
  goBack: () => {},
  resetHistory: () => {},
});

type Props = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: Props) => {
  const [history, setHistory] = useState<string[]>([]);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [goingBack, setGoingBack] = useState(false);

  const goBack = () => {
    if (history.length > 1) {
      const backUrl = history[history.length - 2];
      setHistory(history.slice(0, history.length - 1));
      setGoingBack(true);
      if (backUrl !== pathname) {
        navigate(-1);
      } else {
        navigate("/");
      }
    } else {
      navigate("/");
    }
  };

  const resetHistory = () => setHistory([]);

  useEffect(() => {
    if (goingBack) {
      setGoingBack(false);
    } else {
      setHistory((prev) => [...prev, pathname]);
    }
  }, [pathname, goingBack]);

  return (
    <AppContext.Provider value={{ history, goBack, resetHistory }}>
      {children}
    </AppContext.Provider>
  );
};
